import {EventDetailQuizList} from "components/layout/event/EventDetailQuizRow";
import utilStyles from "styles/utils.module.scss";
import {LazyImage} from "components/sections/product/ProductInfoSection";
import classNames from "classnames";
import {useMemo, useRef} from "react";
import EventSelfVerificationComponent from "components/event/EventSelfVerificationComponent";
import {toast} from "react-toastify";
import Clipboard from "react-clipboard.js";
import {getEventRoute, SITE_URL} from "common/const";
import KakaoLoader, {kakaoShareCallback} from "components/KakaoLoader";


const LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_IMAGE_SIZE = 'evt_dtl_bnr_img_size';
const LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED = 'evt_dtl_dtl_img_expanded';
const LOCAL_STORAGE_KEY_EVENT_DETAIL_IMAGE_SIZE = 'evt_dtl_dtl_img_size';

const EventDetailComponentImage = (props) => {
    const {component, imageInfo, onCouponDownload, onLinkClick, isExpanded, event} = props;
    const bannerDetailImageSizeRef = useRef([]);
    const clipboardRef = useRef(null);

    const previousSizeInfo = useMemo(() => {
        if (typeof window === 'undefined') return {};
        const bannerImageSizeString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_IMAGE_SIZE);
        // const detailImageExpandedString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED);
        const detailImageSizeString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_IMAGE_SIZE);


        const bannerImageSize = bannerImageSizeString ? JSON.parse(bannerImageSizeString) : {};
        // const detailImageExpanded = detailImageExpandedString ? JSON.parse(detailImageExpandedString) : {};
        const detailImageSize = detailImageSizeString ? JSON.parse(detailImageSizeString) : {};

        return {
            bannerImageSize: bannerImageSize.stateKey === window.history.state.key ? bannerImageSize[component.id] || {} : {},
            detailImageExpanded: true,
            detailImageSizeArray: (
                detailImageSize.stateKey === window.history.state.key ?
                    (detailImageSize[component.id] ? detailImageSize[component.id].sizes || [] : []) :
                    []
            ),
        };
    }, [component]);

    const onImageButtonClick = (button) => {
        if (button.type === '쿠폰' && !button.requires_self_authentication) {
            onCouponDownload(button.coupon_mold_keys)
        } else if (button.type === '링크') {
            onLinkClick(button.link, event.id);
        } else if (button.type === '카카오톡 공유') {
            kakaoShareCallback(event.name, shareLink);
        }
    };


    const shareLink = `${SITE_URL}${getEventRoute(event.id)}`;

    const getButtonComponentParent = (button, child) => {
        if (button.type === '링크 복사') {
            return <Clipboard
                option-text={() => shareLink}
                onSuccess={() => {
                    toast.info('링크를 복사했어요');
                }}
            >
                {child}
            </Clipboard>
        } else if (button.type === '카카오톡 공유') {
            return (
                <>
                    <KakaoLoader/>
                    {child}
                </>
            )
        } else {
            return child;
        }

    };

    const onLazyImageLoad = ({target: img}, idx) => {
        bannerDetailImageSizeRef.current[idx] = {
            width: img.width,
            height: img.height,
        }
        const originalBannerDetailSizeInfo = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_IMAGE_SIZE);
        if (originalBannerDetailSizeInfo) {
            const parsedOriginalBannerDetailSizeInfo = JSON.parse(originalBannerDetailSizeInfo);
            if (parsedOriginalBannerDetailSizeInfo.stateKey === window.history.state.key) {
                parsedOriginalBannerDetailSizeInfo[component.id] = {
                    sizes: bannerDetailImageSizeRef.current,
                }
                localStorage.setItem(
                    LOCAL_STORAGE_KEY_EVENT_DETAIL_IMAGE_SIZE,
                    JSON.stringify(parsedOriginalBannerDetailSizeInfo)
                );
            }
        } else {
            localStorage.setItem(
                LOCAL_STORAGE_KEY_EVENT_DETAIL_IMAGE_SIZE,
                JSON.stringify({
                    stateKey: window.history.state.key,
                    [component.id]: {
                        sizes: bannerDetailImageSizeRef.current,
                    }
                })
            );
        }
    };

    return (
        <div>
            <div>
                <div>
                    {
                        imageInfo.detail_image_urls.map((image, idx) => {
                            const buttons = imageInfo.detail_image_buttons;
                            const detailImageSize = previousSizeInfo.detailImageSizeArray[idx];
                            const isDetailImageSaved = !!detailImageSize?.width && !!detailImageSize?.height;
                            return (
                                <div
                                    className={classNames(utilStyles.relative, utilStyles.transparentChildButton)}
                                    key={`component-${component.id}-image-${idx}`}
                                    style={isDetailImageSaved ? {
                                        height: 0,
                                        paddingTop: `${((detailImageSize.height / detailImageSize.width) * 100).toFixed(3)}%`,
                                    } : {}}>
                                    <LazyImage
                                        style={
                                            isDetailImageSaved ? {
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                            } : undefined
                                        }
                                        onLoad={(arg) => onLazyImageLoad(arg, idx)}
                                        eager={true} key={idx} src={image} alt={`이벤트 상세 이미지 ${idx}`}
                                    />
                                    {
                                        buttons.length > 0 &&
                                        buttons.map(button => {
                                            const imageWidth = button.image_width;
                                            const imageHeight = button.image_height;
                                            const x1 = button.x1;
                                            const x2 = button.x2;
                                            const y1 = button.y1;
                                            const y2 = button.y2;

                                            const buttonWidth = `${(Math.abs(x2 - x1) / imageWidth * 100).toFixed(2)}%`;
                                            const buttonHeight = `${(Math.abs(y2 - y1) / imageHeight * 100).toFixed(2)}%`;
                                            const top = `${(Math.abs(y1) / imageHeight * 100).toFixed(2)}%`;
                                            const left = `${(Math.abs(x1) / imageWidth * 100).toFixed(2)}%`;
                                            return getButtonComponentParent(button,
                                                <div
                                                    onClick={() => onImageButtonClick(button)}
                                                    key={button.id}
                                                    className={classNames(utilStyles.absolute, utilStyles.cursorPointer)}
                                                    style={{
                                                        zIndex: 5,
                                                        top: top,
                                                        left: left,
                                                        width: buttonWidth,
                                                        height: buttonHeight
                                                    }}
                                                >
                                                    {
                                                        button.type === '쿠폰' && !!button.requires_self_authentication &&
                                                        <EventSelfVerificationComponent
                                                            event={event} button={button}
                                                            onCouponDownload={onCouponDownload}
                                                        />
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    )
};

export default EventDetailComponentImage;
